import axios from 'axios'
import Global from './globalname.js'
import Common from '@/assets/common'
import common2 from "@/assets/js/common"
import registryMessage from '../components/message/index'
import interfaces from './index'
import Vue from 'vue';
import router from '@/router'
import md5 from 'js-md5'
Vue.use(registryMessage);
import { Indicator } from "mint-ui";
import { Toast } from "vant";
let serviceUrl = '/webhandler.ashx'
let appId = 'ClientService'
let noErrorMsg = [110, 100048, 152005]; // 不需要报错的code
// 100048机票有重复订单，152005行李有重复订单
export default function Fetch() {
    this.fetch = async (actionType, args = {}, type = false, timeout=20000) => {
        let ischeckLogin = false; // 判断是不是要登录
        if (actionType === 'ischeckLogin') {
           ischeckLogin = true;
           actionType = 'AccountService_UserDetailInfoHandler';
           type = 'isloginpage';
        }
        let res = await this._request(actionType, args, type, timeout);
        if (res.data.ErrorCode === 0) {
            if (res.data.Result) {
                res.data.Result = JSON.parse(res.data.Result);
                res.data.result = res.data.Result;
            }
        } else if (noErrorMsg.indexOf(+res.data.ErrorCode) == -1) {
            let msg = '';
            if (res.data.Result) {
                msg = res.data.Result;
            }
            if (res.data.message) {
                msg = res.data.message;
            }
            // 未登入
            if(res.data.ErrorCode == 100001){
                if (!ischeckLogin) {
                  router.push(`/login`);
                }
            }
            if (!type) {
                console.log('aaaa');
                setTimeout(() => {
                    Toast({
                        message:`错误提示：${msg}`,
                        duration: 2000,
                    });
                }, 0)
                
                // new Vue().$msg(msg, 'alert');
            } else if (type === 'alert') {
                new Vue().$msg(msg, 'alert');
            } else if (type === 'isloginpage') {
                // 什么都不做
            }
        }
        return res
    }
    this._request = async (actionType, args, type, timeout) => {
        let headers = {
            // "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            "Content-Type": "application/json; charset=UTF-8",
            // 'Cookie': 'ASP.NET_SessionId=5b406349-8f73-44cd-813f-5feccbf077e4;SESSION=NWI0MDYzNDktOGY3My00NGNkLTgxM2YtNWZlY2NiZjA3N2U0'
        }
        // common2.setCookie('sessionid','c899439e-3788-49b0-956d-7126f75f088b');
        // common2.setCookie('a_sp._ne_t_session_id', 'c899439e-3788-49b0-956d-7126f75f088b')
        // console.log(199999999999)
        let paras = {
            ActionType: "",
            SessionId: "",
            Args: args
        }
        // 如果是0的话是呼叫中心外链支付或APP内嵌页面
        if (paras.Args.SaleChannel != 78 && paras.Args.SaleChannel != 8 && paras.Args.SaleChannel != 77) {
            if (process.env.NODE_ENV === 'development' && !paras.Args.SaleChannel) {
                paras.Args.SaleChannel = 1;
            } else {
                paras.Args.SaleChannel = Global.H5AppSaleChannel;
            }
        }
        if (actionType==='AccountService_GetPhoneVerifyCodeHandler' && type === 'isGetCode') {
            paras.Args.SaleChannel = 101; // 用于小程序和app的部分无横验证
        }
        // 如果是支付宝环境这个接口改为渠道82
        if (Common.curPayEnv() == "AliPayUnifyWap") {
            paras.Args.SaleChannel = 82;
        }
       
        paras.ActionType = actionType
        paras.MethodName = paras.ActionType
        paras.AppID = appId 
        if(Global.fpObj[actionType]){
            const userInfo = await interfaces.dpUserDetailInfo().catch(err => console.error(err));
            if(userInfo && userInfo.data.ErrorCode === 0){
                    const {openId, userGroup} = userInfo.data.Result;
                    const random = Math.floor((Math.random()*0.7+0.1)*10000);
                    const h = random + userGroup;
                    const e = (+(`${random}`.split('').reverse().join('')) * 6 + 3 + userGroup).toString().padStart(8, '0');
                    const f = h + Date.now().toString() + e;
                    paras.Args.cross = f;
                    paras.Parameters = paras.Args = JSON.stringify(paras.Args)
                    console.log(Global.b+`_${openId}_${JSON.stringify(paras)}`);
                    const md5token = md5(Global.b+`_${openId}_${JSON.stringify(paras)}`).toUpperCase();
                    headers['a'] = md5token;
            }
        } else {
            paras.Parameters = paras.Args = JSON.stringify(paras.Args)
        }
        
        // let postData = {
        //     paras: paras
        // };
        return new Promise((resolve, reject) => {
            axios({
                url: serviceUrl,
                transformRequest: [
                    function (data) {
                        data = "paras=" + JSON.stringify(paras);
                        return data;
                    }
                ],
                // data: postData || {},
                headers: headers,
                method: 'POST',
                // timeout: timeout
            }).then((suc) => {
                resolve(suc);
            }).catch(function (error) {
                Indicator.close();
                if(actionType === 'PsgService_FlightCompensatePassengerSubmit') {
                    let obj = {
                        data: {
                            ErrorCode: 9999,
                            message: '系统异常',
                        },
                    };
                    resolve(obj);
                } else {
                    reject(error);
                };
            });
        })
    },
    this.fetchMall = async (actionType, args = {}, type) => {
        let res = await this._requestMall(actionType, args);
        if (res.status === 200) {
            // 提示处理
            res.data.errorCode = parseInt(res.data.errorCode);
            if (res.data.errorCode != 0 && type != 'noalert') {
                    Toast({
                        message:res.data.message,
                        duration: 2000,
                    });
            }
            if (res.data.errorCode == 0) {
                if (res.data.result && res.data.result.token) {
                    let token = res.data.result.token;
                    sessionStorage.setItem('token', JSON.stringify(token));
                }
            } else if (res.data.errorCode == '100001') {
                router.push(`/login`);
            }
        }
        return res
    }
    this._requestMall = async (actionType, args) => {
        let headers = {
            "Content-Type": "application/json; charset=UTF-8"
            // "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
        let postData = args;
        let token = '';
        if (sessionStorage.getItem('token')) {
            token = JSON.parse(sessionStorage.getItem('token'))
        }
        postData.token = token;
        let mallType = Global.mallType;
        if(args.mallType){
            mallType = args.mallType;
        }
        postData.mallType = parseInt(mallType);
        postData.orderChannel = Global.orderChannel;
        // postData.SaleChannel = 83;
        let prodEnv = location.protocol == 'https:'?true:false;
        return new Promise((resolve, reject) => {
            axios({
                url: prodEnv?'mall/'+actionType:actionType,
                data: postData || {},
                headers: headers,
                method: 'POST'
            }).then((suc) => {
                resolve(suc);
            }).catch(function (error) {
                reject(error);
            });
        })
    }
}


// WEBPACK FOOTER //
// ./src/interfaces/fetch.js